export const services = [
  {
    id: "inquiries",
    title: "Hard Inquiries",
    timeline: "7 to 30 Days",
    description:
      "We dispute unauthorized and excessive hard inquiries that are dragging down your credit score. Results typically seen within 7 to 30 days.",
    icon: "ri-search-line",
  },
  {
    id: "late-payments",
    title: "Late Payments",
    timeline: "30 / 45 Days",
    description:
      "Late payments on credit cards, loans, and mortgages can be removed through strategic dispute filing. Expect results in 30 to 45 days.",
    icon: "ri-calendar-close-line",
  },
  {
    id: "collections",
    title: "Collections",
    timeline: "45 Days",
    description:
      "Third-party collection accounts are aggressively disputed using the Fair Credit Reporting Act. Most collections are resolved within 45 days.",
    icon: "ri-archive-line",
  },
  {
    id: "chargeoffs",
    title: "Charge-Offs",
    timeline: "60 Days",
    description:
      "We challenge charge-off accounts with creditors and bureaus to verify accuracy and completeness. Typical removal within 60 days.",
    icon: "ri-close-circle-line",
  },
  {
    id: "repos",
    title: "Repossessions",
    timeline: "60 to 90 Days",
    description:
      "Vehicle repossessions and deficiency balances are targeted for removal or correction on your report. Timeline: 60 to 90 days.",
    icon: "ri-car-line",
  },
  {
    id: "foreclosures",
    title: "Foreclosures",
    timeline: "90 Days",
    description:
      "Foreclosure records are disputed for accuracy, and we work to have outdated or unverifiable foreclosures removed within 90 days.",
    icon: "ri-home-line",
  },
  {
    id: "medical",
    title: "Medical Bills",
    timeline: "30 to 60 Days",
    description:
      "Medical debt collections and billing errors are a common credit problem. We handle medical disputes with full HIPAA compliance.",
    icon: "ri-hospital-line",
  },
];

export const processSteps = [
  {
    id: 1,
    title: "Run Your Credit Report",
    description:
      "We obtain your credit reports from all three major bureaus — Experian, Equifax, and TransUnion — and identify every negative item affecting your score.",
    icon: "ri-file-list-3-line",
  },
  {
    id: 2,
    title: "Free Consultation",
    description:
      "Set up a time for a one-on-one phone consultation with a real credit expert. We will review your report, explain your options, and create a custom plan.",
    icon: "ri-user-voice-line",
  },
  {
    id: 3,
    title: "Dispute Filing",
    description:
      "Our team files disputes using the Fair Credit Reporting Act of 1984. Every letter is customized and sent directly to creditors and credit bureaus.",
    icon: "ri-mail-send-line",
  },
  {
    id: 4,
    title: "We Get Back to You in 48 Hours",
    description:
      "After filing, we keep you updated every step of the way. Expect to hear back from us within 48 hours with status updates and next steps.",
    icon: "ri-feedback-line",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "James R.",
    location: "Houston, TX",
    quote:
      "I had 12 collections and 8 late payments. Authentic Credit Restoration got them all removed in under 3 months. My score went from 480 to 720. I just closed on my first home!",
    rating: 5,
  },
  {
    id: 2,
    name: "Monica S.",
    location: "Atlanta, GA",
    quote:
      "I was turned down for a car loan twice before calling. They removed 6 inquiries and 3 charge-offs from my report. Two months later I drove off the lot in a brand new car.",
    rating: 5,
  },
  {
    id: 3,
    name: "Darnell J.",
    location: "Las Vegas, NV",
    quote:
      "The one-on-one consultation made all the difference. A real expert walked me through everything — not a robot. My score jumped 110 points and I got approved for a business line of credit.",
    rating: 5,
  },
];

export const faqs = [
  {
    id: 1,
    question: "How does Authentic Credit Restoration work?",
    answer:
      "Everything we do is based on the Fair Credit Reporting Act of 1984. We pull your credit reports, file customized disputes with creditors and bureaus, and follow up until negative items are removed. You get a one-on-one consultation with a real expert — never a robot.",
  },
  {
    id: 2,
    question: "Do you work with corporate credit too?",
    answer:
      "Yes! We fix both personal and corporate credit in all 50 states. Whether you are an individual trying to buy a home or a business owner seeking a line of credit, we have the expertise to help.",
  },
  {
    id: 3,
    question: "How long before I see results?",
    answer:
      "It depends on the items: inquiries 7 to 30 days, late payments 30 to 45 days, collections 45 days, charge-offs 60 days, repossessions 60 to 90 days, foreclosures 90 days, and medical bills 30 to 60 days. We update you within 48 hours of every filing.",
  },
  {
    id: 4,
    question: "What happens after my credit is restored?",
    answer:
      "After your credit is restored, we can assist you with personal and business credit lines. We guide you through applying for credit cards, loans, and business financing so you can keep your score strong and growing.",
  },
];

export const stats = [
  { label: "States Served", value: "50", suffix: "" },
  { label: "Personal & Corporate", value: "Both", suffix: "" },
  { label: "Operating Since", value: "1984", suffix: " Law" },
  { label: "Response Time", value: "48", suffix: " Hours" },
];